module.exports = __webpack_public_path__ + "img/Mockup5@2x.4a8a1634.png";